import Nav from 'components/Nav';
import Content from 'components/Content';
import Typography from 'components/Typography';
import Spacer from 'components/Spacer';
import Footer from 'components/Footer';

import classes from 'styles/pages/Diversity/diversity.module.scss';

import { EMPLOYERS_LINK, FEDERAL_BENEFITS } from 'utils/constants/urls';

const navLinks = [
  { text: 'Why MetLife Legal Plans?', href: '/why-enroll' },
  { text: 'How We Work', href: '/#how-we-work' },
  { text: 'Reviews', href: '/#reviews' },
  { text: 'About Us', href: '/about-us' },
  { text: 'Who We Serve', href: '/who-we-serve' },
  { text: 'For Employers', href: EMPLOYERS_LINK, external: true },
  { text: 'For Federal Government', href: FEDERAL_BENEFITS, external: true },
];

const OPTIONS = [
  {
    label: '',
    image: 'BabyBoomers.png',
  },
  {
    label: '',
    image: 'GenerationX.png',
  },
  {
    label: '',
    image: 'Millenials.png',
  },
  {
    label: '',
    image: 'Generation-Z.png',
  },
];

const MLP_ITEMS = [
  {
    icon: 'icon-leadership-and-workforce.png',
    title: 'TRUSTED LEADERSHIP AND WORKFORCE',
    description:
      'Our employees reflect the wide range of communities and customers we serve. Many of our most critical customer-facing roles—like those in our call centers—are filled by professionals who bring a variety of perspectives and backgrounds, helping build stronger connections and trust with our members.',
  },
  {
    icon: 'icon-our-attorney-network.png',
    title: 'A NATIONWIDE ATTORNEY NETWORK ',
    description:
      'With over 18,000 experienced attorneys across the country, our network represents a wide cross-section of legal professionals with varied specializations and backgrounds. That range allows us to offer more options and make it easier for members to find an attorney they feel comfortable with.',
  },
  {
    icon: 'icon-recruitment-practices.png',
    title: 'TAILORED MEMBER SUPPORT',
    description:
      'We actively seek professionals who understand the many ways legal challenges can show up in people’s lives. Our goal is to ensure that your employees can speak with someone who truly understands their concerns and can provide meaningful guidance.',
  },
];

const Diversity = () => (
  <>
    <Nav links={navLinks} />
    <main role="main">
      <div className={classes.bannerContainer}>
        <img src="diversity/team-meeting.png" className={classes.teamBanner} alt="" />
        <div className={classes.textContainer}>
          <div className={classes.headerText}>
            <Typography>
              <strong>A plan</strong> for everyone
            </Typography>
          </div>
          <div className={classes.introText}>
            <Typography bold>
              At MetLife Legal Plans, we believe that everyone deserves access to the legal support
              they need. Our work is rooted in helping individuals navigate the legal system with
              confidence—no matter who they are or where they are in life.
            </Typography>
          </div>
        </div>
      </div>
      <Content>
        <div className={classes.gradientBar} />

        <Typography>
          Our multi-prong approach to legal coverage and services stems from an understanding that
          the law touches every aspect of an individual’s life.{' '}
          <b>
            We are devoted to recruiting employees and attorneys who can shed light on people’s
            unique legal situations, which translates to broad coverage options, including:
          </b>
        </Typography>

        <Spacer v={16} />

        <div className={classes.serviceBlock}>
          <div className={classes.imageGrid}>
            {OPTIONS.map(({ label, image }) => (
              <div key={label} className={classes.imageContainer}>
                <img src={`diversity/${image}`} alt="" />
                <Typography bold className={classes.imageLabel}>
                  {label}
                </Typography>
              </div>
            ))}
          </div>
        </div>

        <Typography className={classes.justiceSystemHeader}>
          OUR COMMITMENT TO ACCESSIBLE LEGAL SUPPORT
        </Typography>
        <div className={classes.gradientBar} />

        <Typography>
          We’ve designed our services to make legal help easier to access, more relatable, and more
          trusted—across generations, regions, and life situations. Here’s how we do it:
        </Typography>

        {MLP_ITEMS.map(({ icon, title, description }) => (
          <div key={title} className={classes.itemContainer}>
            <div className={classes.icon}>
              <img src={`diversity/${icon}`} alt="" />
            </div>
            <div className={classes.itemText}>
              <Typography bold style={{ color: '#0091D8' }}>
                {title}
              </Typography>
              <Typography>{description}</Typography>
            </div>
          </div>
        ))}

        <div>
          <Typography className={classes.justiceSystemHeader}>TRUST STARTS WITH CARE</Typography>
          <div className={classes.gradientBar} />

          <Typography>
            By offering a legal plan benefit, employers can support the unique needs of their
            workforce—across generations, backgrounds, and life experiences—building trust and
            demonstrating care in a way that resonates with employees both personally and
            practically. Our research shows that employees enrolled in a legal plan are
            significantly more likely to agree that their employers’ benefits will be there for
            them.<sup>16</sup> This leads to higher levels of benefits satisfaction overall and
            translates into higher financial confidence.
          </Typography>

          <Spacer v={36} />

          <p style={{ textAlign: 'center', fontSize: '24px' }}>
            <strong>Trust in employer’s benefits offering:</strong>{' '}
            <strong style={{ color: '#8dc63f' }}>Enrolled in Legal Services</strong>{' '}
            <strong>vs</strong> <strong style={{ color: '#0096e6' }}>non-enrolled</strong>
            <sup>16</sup>
          </p>

          <Spacer v={36} />
          <div className={classes.pie}>
            <img src="diversity/trustEmp.png" alt="" />
            <img src="diversity/uncertainTimes.png" alt="" />
            <img src="diversity/companyBenefits.png" alt="" />
          </div>
          <Spacer v={36} />

          <Spacer v={50} />

          <img src="diversity/bargraph.png" className={classes.teamBanner} alt="" />

          <Spacer v={36} />

          <div className={classes.wrapper}>
            <div className={classes.notableBusinesses}>
              <img src="diversity/wrapperImage.png" className={classes.back} alt="" />
            </div>
          </div>

          <div className={classes.contactBar}>
            Contact us to learn more:&nbsp;
            <a href="mailto:clientservice@legalplans.com" className={classes.emailLink}>
              clientservice@legalplans.com
            </a>
          </div>

          <div className={classes.gradientBar} />

          <Typography className={classes.infoText}>
            1 EIN Presswire, "Navigating Uncertainty: Top Legal Concerns for Baby Boomers," 2024
            <br />
            3 CNBC, "Gen Z, millennials are less worried about fraud than older generations," 2024
            <br />
            4 Goldberg Jones, "Breaking down divorce rates by generation" 2024
            <br />
            5 Vanilla, "50 Estate Planning Statistics and Facts You Need to Know," 2024
            <br />
            6 NewsNation, "Tracking debt: Which generation owes the most?," 2024
            <br />
            7 Natixis, "Generation X Report," 2024
            <br />
            8 Guardian, "A Modern Look at Caregivers in the US," 2024
            <br />
            9 Trust & Will, "Millennials and Estate Planning," 2024
            <br />
            10 Apartment List, "2023 Millennial Home Ownership Report," 2023
            <br />
            11 The Zebra, "Which generation has the worst driving behavior?" 2024
            <br />
            12 Thriving Center of Psychology, "Gen Z, Millennials Shifting Expectations About
            Marriage in 2023," 2023
            <br />
            13 CNBC, "Why millennials' retirement outlook may be worse than those of older
            generations," 2024
            <br />
            14 Forbes, "Why Gen-Z Is Suddenly Creating Wills And Trusts,"2024
            <br />
            15 Arbor, "Why Generation Z Is Leaning Into the Renting Lifestyle," 2024
            <br />
            16 Employer Benefits Trend Study, MetLife, 2025
            <br />
          </Typography>
        </div>
      </Content>
    </main>
    <Footer />
  </>
);

export default Diversity;
